const ITEMS = [
  "Document printing",
  "Spiral binding",
  "Wiro binding",
  "Thesis hard cover",
  "UV stickers",
  "Fast delivery",
  "Lower Parel",
  "BKC",
  "Fort",
  "Andheri",
  "Nariman Point",
];

function Track({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center shrink-0">
          <span className="font-display font-medium text-xl sm:text-3xl text-paper/90 px-6 whitespace-nowrap">
            {item}
          </span>
          <span className="w-2.5 h-2.5 rounded-full bg-mag shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="border-y border-edge bg-surface/60 py-6 overflow-hidden"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Track />
        <Track hidden />
      </div>
    </section>
  );
}
